import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggleable']

  connect() {
    // Ensure the form starts hidden
    if (this.hasToggleableTarget) {
      this.toggleableTarget.classList.add('hidden')
    }
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    console.log('Toggle clicked!')
    console.log('Has toggleable target:', this.hasToggleableTarget)

    if (!this.hasToggleableTarget) {
      console.error('Toggle target not found!')
      return
    }

    const target = this.toggleableTarget
    console.log('Target element:', target)
    console.log('Target has hidden class:', target.classList.contains('hidden'))

    if (target.classList.contains('hidden')) {
      // Show the form
      console.log('Showing form...')
      target.classList.remove('hidden')
      // Focus on the textarea after a brief delay to allow transition
      setTimeout(() => {
        const textarea = target.querySelector('textarea')
        if (textarea) {
          textarea.focus()
        }
      }, 100)
    } else {
      // Hide the form
      console.log('Hiding form...')
      target.classList.add('hidden')
    }
  }
}
